/*
**
constants
**
*/

const vehicleDocumentStatus = {
    NOT_UPLOADED: 0,
    APPROVED: 1,
    PENDING: 2,
    REJECTED: 3
}
const vehicleStatus = {
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2
}
const notificationFlags = {
    ADMIN_SOS_REQUEST: 2000
}
const driverVerificationStatus = {
    NOT_UPLOADED: -1,
    APPROVED: 1,
    PENDING: 0,
    REJECTED: 2
}

const gender = {
    MALE: 1,
    FEMALE: 2,
    OTHERS: 3,
    NOT_KNOWN: 0
}

exports.VehicleTypes = {
    1: "Taxi",
    2: "Bike",
    3: "Autos",
    4: "Shuttle"
};

exports.RideTypes = {
    1: "Normal",
    2: "Shuttle",
    3: "Delivery",
    4: "Normal and Delivery"
};

exports.DocumentTypes = {
    1: "Driver Document"
};

exports.CustomerDocumentTypes = {
    1: "Customer Document"
};

exports.paymentMethod2 = {
    1: "RazorPay",
    2: "Stripe"
}

exports.paymentStatus = {
    0:"PENDING",
    1:"PAID",
    2:"FAILED",
    3:"PARTIALLY PAID"
}

// exports.panelRoles = {
//     SUPERADMIN : 1,
//     ADMIN      : 2,
//     FLEET      : 3
// }

exports.SidebarTabs = {
    CUSTOMER: 1,
    VEHICLETYPE: 2,
    DRIVERDOCS: 3,
    HOMESCREEN: 4,
    FLEETS: 5,
    MANAGERSETTINGS: 6,
    GEOFENCE: 7,
    CORPORATE: 8,
    RIDES:9,
    ANALYTICS:10,
    SURGEPRICING: 11,
    GENERALSETTINGS: 12,
    CITYSETTINGS: 13,
    SCHEDULERIDE: 14,
    CUSTOMZONE: 15,
    PROMOTIONS: 16,
    DISPATCHER: 17,
    MAPVIEW: 18,
    DASHBOARD: 19,
    SHUTTLESTOPS: 20,
    SHUTTLEROUTES: 21,
    SHUTTLEVEHICLE: 22,
    SHUTTLEFARE: 23,
    SHUTTLETRIP: 24,
    SHUTTLEBOOKING: 25,
    SHUTTLECNCELLATION: 26,
    SHUTTLESUBSCRIPTION: 27,
    OPERATIONALCITIES: 28,

    VEHICLEINFORMATION: 29,
    PUSHES : 30,
    SHUTTLE_CANCELLATION_REASONS: 31,
    TMS_CLIENT: 32,
    TMS_HELPER: 33,
    TMS_TRUCK_VENDORS: 34,
    TMS_LOCATIONS: 35,
    TMS_CHASSIS: 36,
    TMS_INSPECTION: 37,
    TMS_BOOKING: 38,
    TMS_TRUCKHEAD: 39,
    DRIVER: 40,
    TMS_ASSIGNED_DISPATCH: 41,
    TMS_UNASSIGNED_DISPATCH: 42,
    TMS_CANCELLED_DISPATCH: 43,
    TMS_ONGOING_DISPATCH: 44,
    TMS_DELIVERED_DISPATCH: 45,
    TMS_FOUL_DISPATCH: 46,

    AIRPORT_TRANSFER_REQUESTED_BOOKING: 47, //request bookings
    TMS_BOOKING_SETTINGS: 48,
    TMS_CLOCK_TOWER: 49,

    TMS_DASHBOARD: 54,
    ROLES_AND_PERMISSIONS: 55,

    AT_ASSIGNED_TRIPS: 50,
    AT_CANCELLED_TRIPS: 51,
    AT_COMPLETED_TRIPS: 52,
    AT_NO_SHOW_TRIP: 53,
    AT_ONGOING_TRIPS: 56,
    AT_DASHBOARD: 57,
    FUEL_CONSUMPTION: 58,
    DISPUTERIDES: 59,
    AT_ALL_BOOKINGS: 60,
    DELETE_ACCOUNT_REQUEST : 61,
    MANUAL_REQUESTED_TRIPS: 62,
    SUGGESTED_ROUTES: 63,
    TAXI_CANCELLATION_POLICY: 64,
    TAXI_CANCELLATION_REASON: 65,
    SCHEDULED_BOOKINGS: 66,
    REVIEW_SUGGESTIONS: 67,
    SHUTTLE_PROMOTIONS: 68 ,
    SHUTTLE_HOLIDAY: 69 ,
    CHAT_SUGGESTIONS: 70,
    DRIVER_PAYOUT: 71,
    SHIFT_TIMING: 72,
    DRIVER_SUBSCRIPTION: 73,
    CUSTOMERDOCS: 74,
    PARCEL_SETTINGS: 75,
    SHUTTLE_PASS: 76,
    CHAT: 77,
    REQUESTED_RIDES: 79,
    NO_SHOW_SETTINGS: 80,
    PARTNERS: 81,
    CHANGE_DESTINATION:82,
    DRIVER_MISSED_RIDES: 83
};

exports.dispatchTypeConst = {
    0: "Delayed",
    1: "Instant",
    2: "Instant and Delayed"
}

exports.WeekdaysConst = {
    MON: 1,
    TUE: 2,
    WED: 3,
    THUR: 4,
    FRI: 5,
    SAT: 6,
    SUN: 7
}

exports.ShutteWeekdaysConst = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THUR: 4,
    FRI: 5,
    SAT: 6
}

exports.CustomZoneTypeConst = {
    1: "Toll",
    2: "AIRPORT (Pickup or Drop)",
    3: "CONGESTION (Pickup or Drop)",
    4: "GEOFENCE TO GEOFENCE (Pricing)",
    5: "UNSAFE ZONE"
}

exports.customZoneCharge = [1, 2, 3, 4];

exports.panelengagmentStatus = {
    ONGOING: 1,
    COMPLETED: 2,
    CANCELLED: 3,
    MISSED: 4
}
exports.API_KEY = "AIzaSyB9PP9WVCovkYUaRZu3S-ts5sDExixgLsg"

exports.paymentMode = {
    1: "CASH",
    2: "STRIPE",
    3: "RAZORPAY",
    4: "STRIPE CHECKOUT",
    5: "STRIPE CHECKOUT AUTH",
    6: "PAWA PAY",
    7: "PAYSTACK"
}

exports.fareType = {
    0: "Fare Per Stop",
    1: "Fare Per km"
}

exports.subscriptionType = {
    0: "Based on Ride Count",
    1: "Based on Duration",
    2: "Based on Both"
}

exports.loginKeys = [
    "add_driver_enabled_for_panel",
    "driver_vehicle_attachment_enabled",
    "is_client_owned_vehicle",
    "is_tms_add_driver",
    "is_tms_driver",
    "add_customer_enabled_for_panel",
    "is_rizzo_client",
    "taxi_show_mark_arrived_button",
    "taxi_show_start_ride_button",
    "taxi_show_end_ride_button",
    "taxi_show_reassign_ride_button",
    "change_point_to_comma",
    "taxi_show_mark_arrived_button_for_stops",
    "date_format_dd_mm_yy",
    "google_key",
    "activation_deactivation_date_range",
    "panel_customer_specific_address",
    "map_search_preference",
    "show_create_schedule_ride_button",
    "show_action_schedule_ride_column",
    "show_user_code_for_panel",
    "map_search_zone",
    "utc_offset",
    "time_zone_format",
    "default_country_iso_code",
    "remove_driver_pushes",
    "pushes_in_html",
    "remove_add_stops",
    "disable_total_rides_for_taxi",
    "reverse_bid_enabled_panel",
    "enabled_add_client_for_panel",
    "is_bulk_assign_enabled",
    "add_pool_users",
    "show_map_view_cancel_button",
    "dashboard_auto_refresh",
    "hide_fare_on_map_view_cancel",
    "remove_driver_earnings_from_dashboard",
    "is_operational_hours_enabled",
    "is_offering_type_enabled",
    "is_vehicle_decoupling_enabled",
    "is_delivery_enabled",
    "is_customer_fare_factor_enabled",
    "admin_set_driver_online_status ",
    "utc_offset_from_pickup_time",
    "is_trip_invoice_visible",
    "vehicle_set_enabled",
    "driver_no_show_fare_disabled",
    "admin_set_driver_online_status ",
    "ride_event_logs_enabled",
    "shuttle_analytics_reports",
    "hide_user_info",
    "city_manager_enabled",
    "call_masking_enabled",
    
    "is_driver_debt_limit_enabled",
    "user_specific_promo_enabled",
    "show_driver_gps_status",
    "multi_tax_system_enabled"
];

exports.tmsMovementType = {
    1: "Export",
    2: "Import",
    3: "Transfer"
}

exports.tmsContainerSize = {
    1: "Weight",
    2: "Volumetric Weight",
    3: "Standard character"
}

exports.tmsContainerType = {
    1: "Standard",
    2: "Isotainer",
    3: "Reefer",
    4: "Others"
}

exports.truckHeadTypes = {
    1: "Franchise",
    2: "Spot Hire"
}

exports.truckHeadAvailabilityStatus = {
    1: "Inspection",
    2: "Available",
    3: "Absent",
    4: "Repair",
    5: "Break",
    6: "Off"
}

exports.tmsBookingStatus = {
    1: "Unassigned",
    2: "Assigned",
    3: "Ongoing",
    4: "Delivered",
    5: "Cancelled",
    6: "Foul Trips"
}

exports.airportBookingStatus = {
    REQUESTED: -1,
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    MISSED: 4,
    CANCELLED: 5,
    ASSIGNED: 6,
    UNASSIGNED: 7,
    STARTED: 8,
    ENDED: 9,
    CANCELLED: 10,
    NO_SHOW: 11 ,
    ARRIVED_AT_PICKUP: 12,
    JOURNEY_STARTED:13
}

// Booking status colors for background with transparency (15% opacity)
exports.airportBookingBgColors = {
    "-1": "rgba(255, 223, 0, 0.15)",     // REQUESTED – Bright Yellow
    "1": "rgba(108, 117, 125, 0.15)",      // PENDING – Amber (darker yellow)
    "2": "rgba(40, 167, 69, 0.15)",      // APPROVED – Green
    "3": "rgba(220, 53, 69, 0.15)",      // REJECTED – Deep Orange
    "4": "rgba(255, 138, 101, 0.15)",    // MISSED – Soft Red-Orange
    "5": "rgba(220, 53, 69, 0.15)",      // CANCELLED – Red (clearly distinct from REJECTED)
    "6": "rgba(0, 123, 255, 0.15)",      // ASSIGNED – Blue
    "7": "rgba(108, 117, 125, 0.15)",    // UNASSIGNED – Gray
    "8": "rgba(238, 129, 19, 0.25)",     // STARTED – Teal
    "9": "rgba(72, 201, 176, 0.15)",     // ENDED – Light Green-Teal
    "10": "rgba(220, 53, 69, 0.15)",     // CANCELLED (duplicate) – Red
    "11": "rgba(139, 0, 0, 0.15)" ,
    "12": "rgba(238, 129, 19, 0.25)",
    "13": "rgba(255, 229, 135, 0.25)",      
}

// Booking status solid colors for labels and borders
exports.airportBookingSolidColors = {
    "-1": "rgba(255, 223, 0, 1)",     // REQUESTED – Bright Yellow
    "1": "rgba(108, 117, 125, 1)",      // PENDING – Amber (darker yellow)
    "2": "rgba(40, 167, 69, 1)",      // APPROVED – Green
    "3": "rgba(220, 53, 69, 1)",      // REJECTED – Deep Orange
    "4": "rgba(255, 138, 101, 1)",    // MISSED – Soft Red-Orange
    "5": "rgba(220, 53, 69, 1)",      // CANCELLED – Red
    "6": "rgba(0, 123, 255, 1)",      // ASSIGNED – Blue
    "7": "rgba(108, 117, 125, 1)",    // UNASSIGNED – Gray
    "8": "rgb(238, 129, 19)",     // STARTED – Teal
    "9": "rgba(72, 201, 176, 1)",     // ENDED – Light Green-Teal
    "10": "rgba(220, 53, 69, 1)",     // CANCELLED (duplicate) – Red
    "11": "rgba(139, 0, 0, 1)",        // NO_SHOW – Dark Red
    "12": "rgb(238, 129, 19)",     // ARRIVED AT PICKUP – Dark ORANGE
    "13": "rgb(239, 201, 63)",     // ARRIVED AT PICKUP – Dark ORANGE
}

exports.taxiEngagementStatus = {
    ALIVE: 1,
    ACCEPTED: 2,
    ARRIVED: 3,
    TIMEOUT: 4,
    STARTED: 5,
    ENDED: 6,
    REJECTED_BY_DRIVER: 7,
    CANCELLED_BY_CUSTOMER: 8,
    CANCELLED_BY_DRIVER: 9,
    CANCELLED_BY_ADMIN: 10,
    REVERSE_BID_INITIATED_BY_DRIVER: 11,
    REJECTED_BY_CUSTOMER: 12,
    CUSTOMER_NO_SHOW: 13
}

// Add this to your constants file:
exports.taxiEngagementStatusReverse = Object.fromEntries(
  Object.entries(exports.taxiEngagementStatus).map(([k, v]) => [v, k])
);

exports.taxiEngagementStatusSolidColors = {
    ALIVE: "#FF9800",                            // orange — searching for driver
    ACCEPTED: "#6C757D",                         // grey — driver assigned
    ARRIVED: "#0065FF",                          // blue — driver at pickup
    TIMEOUT: "#9E9E9E",                          // muted grey — no response
    STARTED: "#00A76F",                          // green — trip in progress
    ENDED: "#0DBA78",                            // success green — completed
    REJECTED_BY_DRIVER: "#E57373",               // soft red
    CANCELLED_BY_CUSTOMER: "#D14545",            // red
    CANCELLED_BY_DRIVER: "#C62828",              // deeper red
    CANCELLED_BY_ADMIN: "#8E24AA",               // purple — admin action
    REVERSE_BID_INITIATED_BY_DRIVER: "#00ACC1",  // cyan — negotiation
    REJECTED_BY_CUSTOMER: "#EF6C00",             // deep orange
    CUSTOMER_NO_SHOW: "#795548",                 // brown — passive failure
}
exports.shuttleBookingStatus = {
    BOOKED: 1,
    CANCELLED: 2,
    PICKED_UP: 3,
    ENDED: 6,
    MISSED: 7
};

exports.AnalyticsTabs= {
    1: 'Shuttle Bookings',
    2: 'Shuttle Booking Refund Logs',
    3: 'Shuttle Driver Trips',
    4: 'Shuttle Reschedule Reports',
    5: 'Shuttle Stop Utilization Reports',
    6: 'Shuttle Passenger Reports'
}

exports.BookingFieldToShow = {
    1: ['Booking ID',
        'Booking Mode',
        'Source ID',
        'User',
        'Driver',
        'User Email',
        'Date & Time',
        'Pickup Address',
        'Drop Address',
        'Stops',
        'Flight Number', 
        'Vehicle Number',
        'Luggage Count',
        'Number of Seats',
        'Distance (in km)',
        'Duration (in min)',
        'Fare',
        'Tax',
        'Partner Price',
        'Extras',
        'Total Fare',
        'Payment Mode',
        'Payment Status',
        'Status',
        'Parent Booking ID',
        'Journey Code',
        'Consent Form URL',
    ],
    170: 
    [   'Booking ID',
        'Source ID',
        'Pickup Address',
        'Drop Address',
        'Fare',
        'Status',
        'Driver',
        'Date & Time',
        'Partner Price',
        'Extras',
        'Total Fare',
        'Consent Form URL',
    ]
}

exports.TripFieldToShow = {
    1: ['Booking ID',
        'Booking Mode',
        'Source ID',
        'User',
        'Driver',
        'Date & Time',
        'Vehicle Number',
        'Distance (in km)',
        'Duration (in min)',
        'Fare',
        'Tax',
        'Extras',
        'Partner Price',
        'Total Fare',
        'Payment Status',
        'Payment Mode',
        'Status',
        'Parent Booking ID',
        'Journey Code',
        'Consent Form URL',
        'Action'
    ],
    170: [
        'Booking ID',
        'Source ID',
        'Fare',
        'Date & Time',
        'Status',
        'Driver',
        'Extras',
        'Partner Price',
        'Total Fare',
        'Parent Booking ID',
        'Consent Form URL',
        'Action'
    ]
}

// Map tab IDs to their corresponding route paths for navigation
exports.TabRoutes = {
    1: "/rider-details",
    2: "/vehicle",
    3: "/driver-documents",
    4: "/homescreen-settings",
    5: "/fleets",
    6: "/manager-settings",
    7: "/geofence",
    8: "/corporate",
    // 9: "/rides",
    10: "/analytics",
    11: "/surge-pricing",
    12: "/general_settings",
    13: "/city_settings",
    14: "/settings/schedule-ride",
    15: "/custom-zone",
    16: "/promotions",
    17: "/dispatch",
    18: "/mapView",
    19: "/mainDashboard", 
    20: "/shuttle/shuttle-stops",
    21: "/shuttle/shuttle-routes",
    22: "/shuttle/shuttle-vehicle",
    23: "/shuttle/shuttle-fare",
    24: "/shuttle/shuttle-journey",
    25: "/shuttle/shuttle-booking",
    26: "/shuttle/shuttle-cancellation",
    27: "/shuttle/shuttle-subscription",
    28: "/operational-cities",
    29: "/vehicle-information",
    30: "/pushes",
    31: "/cancellation-reasons",
    32: "/tms-client",
    33: "/tms-helpers",
    34: "/tms-truck-vendors",
    35: "/tms-locations",
    36: "/tms-chassis",
    37: "/tms-inspection",
    38: "/tms-booking",
    39: "/tms-truckhead",
    40: "/",
    41: "/tms-assigned-dispatch",
    42: "/tms-unassigned-dispatch",
    43: "/tms-cancelled-dispatch",
    44: "/tms-ongoing-dispatch",
    45: "/tms-delivered-dispatch",
    46: "/tms-foul-dispatch",
    47: "/airport-transfer-booking",
    48: "/tms-booking-settings",
    49: "/tms-clock-tower",

    50: "/at-assigned-trips",
    51: "/at-cancelled-trips",
    52: "/at-completed-trips",
    53: "/at-no-show-trips",
    54: "/tms-dashboard",
    55: "/roles_and_permissions",

    56: "/at-ongoing-trips",
    57: "/at-dashboard",
    58: "/fuel-consumption",
    59: "/dispute-rides",
    60: "/all-bookings",
    61: "/delete-account-request",
    62: "/manual-trips",
    63: "/shuttle/fetch_suggested_routes",
    64: "/taxi-cancellation-policy",
    65: "/taxi-cancellation-reason",
    66: "/scheduled-bookings",
    67: "/shift-timing"
};

exports.clientColumnConfig = {
    '188': {
        'default': ['pickup_latitude', 'engagement_id', 'pickup_longitude', 'drop_latitude', 'drop_longitude'],
        'ongoing': ['pickup_latitude', 'pickup_longitude', 'drop_latitude', 'drop_longitude','client_vehicle_id','vehicle_type','driver_id','payment_mode','estimated_fare','drop_time','total_fare','driver_fare','distance_fare','time_fare','commission','platform_fee','toll_charge','waiting_charge','waiting_charges_driver_cut','stops_waiting_charges','luggage_charges','convenience_fee','convenience_driver_cut','tax','customer_review','driver_review','waiting_charges','pickup_distance_charges','pickup_distance_charges_driver_cut'],
        'completed': ['pickup_latitude', 'pickup_longitude', 'drop_latitude', 'drop_longitude','client_vehicle_id','vehicle_type','driver_id','payment_mode','estimated_fare','drop_time','total_fare','driver_fare','distance_fare','time_fare','commission','platform_fee','toll_charge','waiting_charge','waiting_charges_driver_cut','stops_waiting_charges','luggage_charges','convenience_fee','convenience_driver_cut','tax','waiting_charges','pickup_distance_charges','pickup_distance_charges_driver_cut'],
        'cancelled': ['pickup_latitude', 'pickup_longitude', 'drop_latitude', 'drop_longitude','client_vehicle_id','vehicle_type','driver_id','payment_mode','estimated_fare','drop_time','total_fare','driver_fare','distance_fare','time_fare','commission','platform_fee','toll_charge','waiting_charge','waiting_charges_driver_cut','stops_waiting_charges','luggage_charges','convenience_fee','convenience_driver_cut','tax','customer_review','driver_review','waiting_charges','pickup_distance_charges','pickup_distance_charges_driver_cut'],
        'timeout': ['pickup_latitude', 'pickup_longitude', 'drop_latitude', 'drop_longitude','client_vehicle_id','vehicle_type','driver_id','payment_mode','estimated_fare','drop_time','total_fare','driver_fare','distance_fare','time_fare','commission','platform_fee','toll_charge','waiting_charge','waiting_charges_driver_cut','stops_waiting_charges','luggage_charges','convenience_fee','convenience_driver_cut','tax','waiting_charges','pickup_distance_charges','pickup_distance_charges_driver_cut'],
        'scheduledbooking': ['pickup_latitude', 'pickup_longitude', 'drop_latitude', 'drop_longitude','client_vehicle_id','vehicle_type','driver_id','payment_mode','estimated_fare','drop_time','total_fare','driver_fare','distance_fare','time_fare','commission','platform_fee','toll_charge','waiting_charge','waiting_charges_driver_cut','stops_waiting_charges','luggage_charges','convenience_fee','convenience_driver_cut','tax','waiting_charges','pickup_distance_charges','pickup_distance_charges_driver_cut','engagement_status','ride_distance','promo_id', 'luggage_count','passenger_count', 'flight_number'],
    },
    'default': {
        'default': []
    }
};


exports.firebaseConfig = {
    '1':{
        appId: "1:470746235999:web:26e6e8d80d71b6a58247ea",
        apiKey: "AIzaSyAD8APRNS9bE0bhDYV9yV6zPm8umjfrIu8",
        projectId: "send-push-92b4e",
        vapid_key: "BFHPe-qJxncYCPjPc00XfBFUloiTU0sBB-S7v5JpHhUvRZ1MwkPhaDyvA6FEvYL3XmzrXXF3-CFVn4nOR84cRNE",
        authDomain: "send-push-92b4e.firebaseapp.com",
        storageBucket: "send-push-92b4e.firebasestorage.app",
        messagingSenderId: "470746235999"
    },
    '273':{
        appId: "1:619048929417:web:ed4042fd04dbc5209c9e58",
        apiKey: "AIzaSyCG_-QmDw3b7_6yXNFgl5cg18WLlxHZAOU",
        projectId: "se-request-a-ryde",
        vapid_key: "BOHGKZNmbxVQG4quWcto_gBqTMuteyds3c3y1P0FjJdIPYwfCHVAMP7UcRk5t5qQPGFCsSmW0hNYnLdq4Qn6jZc",
        authDomain: "se-request-a-ryde.firebaseapp.com",
        storageBucket: "se-request-a-ryde.firebasestorage.app",
        messagingSenderId: "619048929417",
        measurementId: "G-CY881Z9PBP"
    },
    '192':{
        appId: "1:568535926802:web:7086a13bc48f7dffef30cb",
        apiKey: "AIzaSyByNR-LIGKDgtE7AE7BLgF5v54sWbTl9bc",
        projectId: "primekar-e4e28",
        vapid_key: "BE9hog97Fj1HjinKO9PRD5cGFIPv8Gv3Vp3ueIJvowr9ECsMuo1i5t1x3WGJ8fSkzFYvnpmnBRzii-AArC0s97Y",
        authDomain: "primekar-e4e28.firebaseapp.com",
        storageBucket: "primekar-e4e28.firebasestorage.app",
        messagingSenderId: "568535926802",
        measurementId: "G-11LSL4JRLP"
    },
    '188':{
        appId: "1:918914923208:web:4e4e794d3fb48e45be43fd",
        apiKey: "AIzaSyBJ1X2RRvosMr0sjBmI6ieONJ8381zQIiQ",
        projectId: "ecft-ride-93a1a",
        vapid_key: "BPxlHcJdfQgqGh_oNyCXH7E1Vd-K-sDA97QMc2sbD59lU1a2CfaLN74OauEEf_nn8imoHLUKHH4rE6LnAD6sCjY",
        authDomain: "ecft-ride-93a1a.firebaseapp.com",
        storageBucket: "ecft-ride-93a1a.firebasestorage.app",
        messagingSenderId: "918914923208",
        measurementId: "G-Q72KP4BJVP"
    },
    '280':{
        appId: "1:181656500147:web:0d178dbfa2d8527c38fdc6",
        apiKey: "AIzaSyCojqbcIB0wrD-g65ywtukXW3lmzEyjjc8",
        projectId: "ride-vi-hail-417318",
        vapid_key: "BJo1_KJHbRT1XLxueyAbt8pJ9pMpgfBePvZf1m7nPesfU7jDre4Q8S3PZlfaT9qZBWHGuVT-8JvrRKxlj61dYyc",
        authDomain: "ride-vi-hail-417318.firebaseapp.com",
        storageBucket: "ride-vi-hail-417318.firebasestorage.app",
        messagingSenderId: "181656500147",
        measurementId: "G-9913G9RLHE"
    },
    '197':{
        appId: "1:417233566964:web:d9ac7d063e260b4aeb32a1",
        apiKey: "AIzaSyBWxJkN7g7LRAkHt-gFEcDghw10NUm-1Y0",
        projectId: "gala-bus-dfaee",
        vapid_key: "BA1IN85qFsm20SBUP-LxrlSavlFXT5FXQ_7UIOCSlAdDdQ4MZXdOKXN58nusKNEFtuG-zHcns4ReDWgrStt0suA",
        authDomain: "gala-bus-dfaee.firebaseapp.com",
        storageBucket: "gala-bus-dfaee.firebasestorage.app",
        messagingSenderId: "417233566964",
        measurementId: "G-HHTKZSD3ML"
    },
    '394':{
        appId: "1:687177182340:web:970444c53d87a3aad0a6d1",
        apiKey: "AIzaSyAz_mjR0OmhUASE9SOEbTPnUZY-6P5WYOY",
        projectId: "sweet-shuttle",
        vapid_key: "BIptWq7qkQQSJOAVotArfMIbpOBLrYw2f9bDn97-dcRlwXqwmdCEWhbT-of9F7qeK_cT3ljGqRR-Vqq-OrSubvs",
        authDomain: "sweet-shuttle.firebaseapp.com",
        storageBucket: "sweet-shuttle.firebasestorage.app",
        messagingSenderId: "687177182340",
        measurementId: "G-6RMFMGJVVZ"
    },
    '403':{
        appId: "1:470746235999:web:26e6e8d80d71b6a58247ea",
        apiKey: "AIzaSyAD8APRNS9bE0bhDYV9yV6zPm8umjfrIu8",
        projectId: "send-push-92b4e",
        vapid_key: "BFHPe-qJxncYCPjPc00XfBFUloiTU0sBB-S7v5JpHhUvRZ1MwkPhaDyvA6FEvYL3XmzrXXF3-CFVn4nOR84cRNE",
        authDomain: "send-push-92b4e.firebaseapp.com",
        storageBucket: "send-push-92b4e.firebasestorage.app",
        messagingSenderId: "470746235999"
    },
}